import { Component, Input } from '@angular/core';
import { NgForm } from '@angular/forms';
import { SupportFeedbackRepoService } from '@client/app/services/api/support-feedback-repo/support-feedback-repo.service';
import { MonDialog } from '@client/app/modules/dialog-upgrade-wrapper/mon-dialog.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { ToastService } from '@monsido/angular-shared-components';

interface FeedbackFormData {
    recipient_name: string;
    recipient_email: string;
    message: string;
}

@Component({
    selector: 'form-feedback',
    template: `
        <form #feedbackForm="ngForm" (ngSubmit)="onSubmit(feedbackForm)" class="form-horizontal">
            <div class="mon-dialog-header">
                <page-header
                    [header]="translateService.getString('Suggestions and Ideas')"
                    panelLeftClass="col-48 mt-2">
                </page-header>
            </div>
            <div class="mon-dialog-body-with-footer">
                <div class="row">
                    <div class="col-48">
                        <div class="card panel-monsido-card outer-t outer-l outer-r">
                            <div class="card-body">
                                <form-field-input
                                    [placeholder]="translateService.getString('Your name')"
                                    name="name"
                                    [required]="true"
                                    [(ngModel)]="feedback.recipient_name"
                                    [label]="translateService.getString('Name')">
                                </form-field-input>
                                <form-field-errors [input]="feedbackForm.controls['name']"></form-field-errors>

                                <form-field-input
                                    [placeholder]="translateService.getString('Your email address')"
                                    name="email"
                                    [required]="true"
                                    [type]="'email'"
                                    [email]="true"
                                    [(ngModel)]="feedback.recipient_email"
                                    [label]="translateService.getString('Email')">
                                </form-field-input>
                                <form-field-errors [input]="feedbackForm.form.get('email')"></form-field-errors>

                                <form-field-textarea
                                    [placeholder]="translateService.getString('Your message')"
                                    rows="7"
                                    name="message"
                                    [required]="true"
                                    [(ngModel)]="feedback.message"
                                    [label]="translateService.getString('Message')">
                                </form-field-textarea>
                                <form-field-errors [input]="feedbackForm.controls['message']"></form-field-errors>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mon-dialog-footer">
                <div class="row">
                    <div class="col-48 text-right">
                        <button
                            monEventTrigger="actionTrigger"
                            [monEventParams]="{action:'feedback-send'}"
                            type="submit"
                            [disabled]="feedbackForm.invalid || isSubmitting"
                            class="btn btn-border-radius btn-secondary"
                            *ngIf="!isSubmitting">
                            {{ translateService.getString('Send') }}
                        </button>
                        <span
                            class="btn btn-border-radius btn-secondary"
                            *ngIf="isSubmitting">
                            <span class="fas fa-spinner fa-spin fa-fw" aria-hidden="true"></span>
                        </span>
                    </div>
                </div>
            </div>
        </form>
    `,
    standalone: false,
})
export class FormFeedbackComponent {
    @Input() monDialogId: string = '';

    feedback: FeedbackFormData = {
        recipient_name: '',
        recipient_email: '',
        message: '',
    };
    isSubmitting = false;

    constructor (
        private supportFeedbackRepoService: SupportFeedbackRepoService,
        private monDialog: MonDialog,
        public translateService: TranslateService,
        private toastService: ToastService,
    ) {}

    onSubmit (form: NgForm): void {
        if (form.valid) {
            this.isSubmitting = true;

            this.supportFeedbackRepoService
                .create(this.feedback)
                .then(() => {
                    this.toastService.success(this.translateService.getString('Feedback submitted'));
                    this.close();
                })
                .catch(() => {
                    // Error handling is typically done by the service or interceptor
                })
                .finally(() => {
                    this.isSubmitting = false;
                });
        }
    }

    private close (): void {
        this.monDialog.close(this.monDialogId, {});
    }
}
